// ⚠️ FICHIER GÉNÉRÉ — ne pas éditer à la main.
// Régénérer : node scripts/gen-nb-primes.mjs   (npm run nb-primes)
// Vérifier  : node scripts/gen-nb-primes.mjs --verifier
//
// Le pourquoi complet est en tête de scripts/gen-nb-primes.mjs : ce nombre
// est DÉRIVÉ du catalogue PRIMES_DB de app/pages/PrimesAvantagesV2.js, mais au
// build — l'écran est 'use client', un layout serveur ne peut pas l'importer.
// Le verrou __tests__/nb-primes-genere.test.js recompte depuis le catalogue et
// échoue si ce fichier a dérivé : la valeur ne peut ni périmer ni être inventée.

/** Primes et avantages du catalogue, chacun avec son calcul et son régime fiscal. */
export const NB_PRIMES = 57;
